import { Typography } from "@mui/material";
import { RegistrantFilter } from "./registrant-filter";
import { RegistrantResultTable } from "./registrant-result-table";
import { useStyles } from "./registrant-selection.style";
import { useRegistrantSelection } from "./registrant-selection.hook";
import { SearchRegistrationExamineeResponseItem } from 'src/app/modules/Recruitment/types/license-exam-types';
import { ExamPaperSelectionItem } from "../exam-paper-selection/use-exam-paper-selection.hook";
import { SnackbarAlert } from "./snackbar-alert";
import { useTranslation } from "@pruforce/common-adminweb-sdk";

export interface RegistrantSelectionStepProps {
  selectedExamPaper: ExamPaperSelectionItem;
  selectedRegistrantId: string;
  onChange: (registrant: SearchRegistrationExamineeResponseItem | null) => void;
}

export const RegistrantSelectionStep = (props: RegistrantSelectionStepProps) => {
  const t = useTranslation();
  const { selectedExamPaper, selectedRegistrantId, onChange } = props;
  const { classes } = useStyles();
  const {
    filters,
    resultList,
    searching,
    openAlert,
    updateFilter,
    handleSearch,
    handleReset,
    onAlertClose,
  } = useRegistrantSelection({
    examCode: selectedExamPaper?.examCode || '',
    examType: selectedExamPaper?.examType || '',
    resetRegistration: onChange
  });

  return (
    <div className={classes.container}>
      <Typography component="p" className={classes.descriptionText}>
        {t("recruitment.exam.registration.adminRegistration.registrantSelection.selectedExamPaper")} <span className={classes.selectedExamPaperTitle}>{selectedExamPaper?.localized || ''}</span>
      </Typography>

      <RegistrantFilter
        filters={filters}
        searching={searching}
        onChange={updateFilter}
        onSearch={handleSearch}
        onReset={handleReset}
      />

      <SnackbarAlert
        open={openAlert}
        onClose={onAlertClose}
        message={t("recruitment.exam.registration.adminRegistration.registrantSelection.filter.atLeastOneSearchCriteria")} />

      <div className={classes.resultSectionHeader}>
        <Typography variant="h6" className={`${classes.sectionTitle} ${classes.resultSectionTitle}`}>
          {t("recruitment.exam.registration.adminRegistration.registrantSelection.searchResult")}
        </Typography>
      </div>

      <RegistrantResultTable
        resultList={resultList}
        searching={searching}
        selectedRegistrantId={selectedRegistrantId}
        onChange={onChange}
      />
    </div>
  );
};
